import { styled } from '@mui/material';

export const PageW = styled('div')`
  padding-left: 38px;
  padding-top: 56px;
  position: relative;
  @media (max-width: 1023px) {
    padding-left: 0px;
    padding-top: 88px;
    padding-bottom: 88px;
  }
`;

export const ListsW = styled('div')`
  display: flex;
  align-items: flex-start;
  margin-top: 16px;
  overflow-x: scroll;
  @media (max-width: 1023px) {
    margin-top: 0px;
    overflow: hidden;
    width: 100%;
  }
`;

export const MobileContainerW = styled('div')`
  width: 100%;
  position: relative;
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(20px);
  padding: 16px;
  margin-top: 16px;
`;
